<div class="text-danger" *ngIf="control && control.errors && (control.dirty || control.touched)">
    <div *ngIf="control.errors.required">Required</div>
</div>